import React, { useState, useEffect, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { defaultVisitorForBadge } from '../../BadgeDetails/components/BadgeView/BadgeView';

const PREFIX = 'MailTemplateParams';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2),
  },
}));

const templateParams = [
  ['${visitor.firstName}', defaultVisitorForBadge['firstName']],
  ['${visitor.lastName}', defaultVisitorForBadge['lastName']],
  ['${visitor.middleName}', defaultVisitorForBadge['middleName']],
  ['${visitor.photo}', '', 'Тут нужен пример, как вставлять фото'],
  ['${visitor.phoneNumber}', defaultVisitorForBadge['phoneNumber']],
  ['${visitor.email}', defaultVisitorForBadge['email']],
  [
    '${visitor.extended.<field-name>}',
    '',
    'Здесь находятся поля, которые вы создали вручную. Например, если вы создали поле jobPosition, то в шаблоне вы сможете сослаться на него так: ${visitor.extended.jobPosition}',
  ],
  ['${meetup.name}', 'Большой Форум Волшебников', ''],
  // ["${meetup.startTime}", "", ""],
  // ["${meetup.endTime}", "", ""],
  // ["${meetup.timezone}", "", ""],
  ['${group.name}', 'Участник', ''],
  ['${editCancelLink}', 'Ссылка для редактирования записи или для отмены регистрации', ''],
];

const MailTemplateParams = () => {
  return (
    <Root className={classes.root}>
      <Typography variant={'h3'}>Список переменных для использования в шаблонах</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Переменная</TableCell>
            <TableCell>Пример</TableCell>
            <TableCell>Описание</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {templateParams.map(p => (
            <TableRow>
              <TableCell>{p[0]}</TableCell>
              <TableCell>{p[1]}</TableCell>
              <TableCell>{p[2]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Root>
  );
};

export default MailTemplateParams;
